{
  "name": "dolpheen-crm-web",
  "version": "1.1.0",
  "description": "",
  "main": "src/index.tsx",
  "prettier": "@dolpheen-org/common/prettier",
  "scripts": {
    "prepare": "node ./node_modules/@dolpheen-org/common/hooks/install.mjs || exit 0",
    "dev": "VITE_API_URI=http://localhost:3001/graphql VITE_WS_URI=ws://localhost:3001/graphql npm run start",
    "graphql:build-types": "graphql-codegen",
    "graphql:fetch-schema": "graphql-codegen --config ./fetch-schema.yml",
    "graphql:build": "VITE_API_URI=http://localhost:3001/graphql npm run graphql:fetch-schema && npm run graphql:build-types",
    "build": "vite build",
    "build:prod": "vite build --mode production",
    "start": "vite serve",
    "start:prod": "VITE_API_URI=https://dolpheen-crm-core-app-cj4et6evda-et.a.run.app/graphql npm run start",
    "preview": "vite preview",
    "lint": "eslint . --fix",
    "lint:check": "eslint . --max-warnings 0",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "check-types": "tsc --noEmit",
    "intl:extract-messages": "formatjs extract 'src/**/!(*.d)*.{ts,tsx}' --out-file locale/defaultMessages.json --id-interpolation-pattern '[sha512:contenthash:base64:6]'",
    "test": "vitest run",
    "test:watch": "vitest"
  },
  "keywords": [],
  "author": "",
  "license": "ISC",
  "type": "module",
  "dependencies": {
    "@apollo/client": "^4.2.12",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@formatjs/intl": "^4.1.18",
    "@glideapps/glide-data-grid": "6.0.4-alpha24",
    "@mui/icons-material": "^9.3.1",
    "@mui/material": "^9.3.1",
    "@mui/x-charts": "^9.11.1",
    "@mui/x-date-pickers": "^9.11.0",
    "d3-sankey": "^0.12.3",
    "graphql": "^16.14.2",
    "graphql-ws": "^6.2.1",
    "libphonenumber-js": "^1.13.11",
    "lodash-es": "^4.18.1",
    "luxon": "^3.7.2",
    "qs": "^6.15.3",
    "react": "^19.2.8",
    "react-colorful": "^5.8.0",
    "react-dom": "^19.2.8",
    "react-error-boundary": "^6.1.3",
    "react-hook-form": "^7.85.0",
    "react-intl": "^10.1.20",
    "react-number-format": "^5.4.5",
    "react-router": "^8.3.0",
    "url-join": "^5.0.0"
  },
  "devDependencies": {
    "@dolpheen-org/common": "^0.5.1",
    "@formatjs/cli": "^6.16.18",
    "@formatjs/vite-plugin": "^1.1.0",
    "@graphql-codegen/cli": "^7.2.0",
    "@graphql-codegen/client-preset": "^6.1.3",
    "@graphql-codegen/fragment-matcher": "^7.1.0",
    "@graphql-typed-document-node/core": "^3.2.0",
    "@rolldown/plugin-babel": "^0.2.3",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.2",
    "@types/d3-sankey": "^0.12.5",
    "@types/lodash-es": "^4.17.12",
    "@types/luxon": "^3.7.4",
    "@types/qs": "^6.15.1",
    "@types/react": "^19.2.18",
    "@types/react-dom": "^19.2.4",
    "@types/webappsec-credential-management": "^0.6.9",
    "@vitejs/plugin-react": "^6.0.5",
    "babel-plugin-react-compiler": "^1.0.0",
    "eslint": "^9.39.5",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-simple-import-sort": "^14.0.0",
    "jsdom": "^30.0.1",
    "prettier": "^3.9.6",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.67.0",
    "vite": "^8.2.1",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^4.1.10"
  },
  "packageManager": "pnpm@11.22.0"
}
